import AccountSummaryPage from "components/pages/AccountSummaryPage";

/**
 * @name CaptureFirstLoginAccountSummary
 * @returns {React.Component}
 * @description Capture component for the account summary page for the first time login group
 */
export default function CaptureFirstLoginAccountSummary(props) {
    return <AccountSummaryPage />
}